import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["handle-p", { 'row-p': _ctx.type == 'row', 'column-p': _ctx.type == 'column', active: _ctx.handleActive }]),
    onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (
			_ctx.handleDown(), _ctx.resizePanel({ panel1: _ctx.handleIds[0], panel2: _ctx.handleIds[1], type: _ctx.type })
		), ["prevent"]))
  }, null, 34))
}